module.exports = __webpack_public_path__ + "static/media/ios.3c037baa.png";